import { render, staticRenderFns } from "./TrackingPage.vue?vue&type=template&id=163b68ec&"
import script from "./TrackingPage.vue?vue&type=script&lang=js&"
export * from "./TrackingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163b68ec')) {
      api.createRecord('163b68ec', component.options)
    } else {
      api.reload('163b68ec', component.options)
    }
    module.hot.accept("./TrackingPage.vue?vue&type=template&id=163b68ec&", function () {
      api.rerender('163b68ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tracking/TrackingPage.vue"
export default component.exports